export const checkboxIconStyles = theme => ({
  color: theme.palette.graphic.main,
});

export const dividerStyles = theme => ({
  margin: theme.spacing(2, 0),
});

export const headerStyles = theme => ({
  color: theme.palette.primary.dark,
  fontWeight: 'bold',
  padding: theme.spacing(1.5, 0),
});

export const itemStyles = theme => ({
  alignItems: 'center',
  borderBottom: `solid 1px ${theme.palette.graphic.light}`,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
});

export const productStyles = theme => ({
  alignItems: 'center',
  borderBottom: `solid 1px ${theme.palette.graphic.light}`,
  display: 'grid',
  gridAutoColumns: 'min-content 222px min-content min-content',
  gridAutoFlow: 'column',
  gridGap: theme.spacing(2),
  padding: theme.spacing(2),
});
